import * as React from 'react';
import Button from '@mui/material/Button';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { ThemeProvider } from '@mui/material/styles';
import Copyright from '../components/Copyright';
import theme from '../components/theme';
import Stack from '@mui/material/Stack';
import AssessmentIcon from '@mui/icons-material/Assessment';
import samplereport from '../images/samplereport.jpg';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import CircleIcon from '@mui/icons-material/Circle';
import Grid from '@mui/material/Grid';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';

function Home({ user }) {

  return (
    <ThemeProvider theme={theme}>
      {/* Fixed background box outside scrollable content */}
      <Box
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          zIndex: -1,
          backgroundImage: `url('bghome.jpg')`,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      />

      {/* Main scrollable content */}
      <Box sx={{ position: 'relative', zIndex: 1}}>
     <Container component="main" maxWidth="lg">
        <CssBaseline />
        <Box
          sx={{
            marginTop: 8,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            minHeight: "75vh",
            backgroundColor: 'white',
            paddingLeft: "32px",
            paddingRight: "32px"
          }}
        >
      <Typography
        variant="h1"
        component="h1"
        sx={{
          fontSize: '2.4rem',
          fontWeight: 700,
          color: '#0A2A43',
          mt: 2,        // ← NEW: padding above the header
          mb: 1
        }}
      >
        Hire With Confidence
      </Typography>

      {/* Orange accent bar */}
      <Box
        sx={{
          width: '70px',
          height: '6px',
          backgroundColor: '#FF7A00',
          borderRadius: '3px',
          mb: 1.5
        }}
      />

      <Typography
        variant="h2"
        component="h2"
        sx={{
          fontSize: '1.8rem',
          fontWeight: 600,
          color: '#0A2A43',
          mb: 2
        }}
      >
        Science‑Based Pre‑Employment Assessments
      </Typography>

<Box
  sx={{
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    mt: 8
  }}
>
  <img
    src="VEIntro.jpg"
    alt="Venture Evaluations hiring assessment platform — discover exceptional talent with pre‑employment evaluations"
    style={{
      width: '80%',          // ← spans 80% of the container
      maxWidth: '1200px',    // ← prevents it from getting too huge on ultra‑wide screens
      height: 'auto',
      borderRadius: '6px',   // ← nubbed corners
      display: 'block',
      boxShadow: '0 4px 12px rgba(0,0,0,0.08)'
    }}
  />
</Box>


      <Typography variant="body1" sx={{ fontSize: '1.1rem', mt: 1, mb: 3 }}>
        Identify top talent using validated I/O psychology designed to predict long‑term performance.
      </Typography>

          <Typography variant="body1" align="left" sx={{ marginTop: 2 }}>
            <ol style={{ fontSize: '1.2rem' }}>
              <li>Make an account</li>
              <li>Purchase assessment credits</li>
              <li>Submit assessment requests</li>
            </ol>
            Once the applicant completes the assessment, you will receive an emailed report. This report will give you valuable insights into important personality traits of your applicants to aid in your selection process.
          </Typography>

          <Stack
              sx={{ pt: 4, pb: 4}}
              direction="row"
              spacing={2}
              justifyContent="center"
            >
              {!user && ( 
                <>
                  <Button
                    type="button"
                    variant="contained"
                    onClick={() => window.location.href='/signin'}
                    >
                    Sign In
                  </Button>
                  <Button
                    type="button"
                    variant="contained"
                    onClick={() => window.location.href='/signup'}
                    >
                    Sign Up
                  </Button>
                </>
              )}
          </Stack>
          {/* <Carousel/> */}

          <Grid
              container
              spacing={5}
              columns={1}//2
              marginTop={10}
          >
            <Grid item xs={12} sm={12} md={12} lg={1}>
              <Typography component="h1" variant="h5" margin="4px" sx={{
    backgroundColor: 'secondary.main',
    borderRadius: '8px', // Adjust this value to change the roundness
    padding: '8px' // Optional: adds breathing room
  }}>
              Value
              </Typography>
              <Typography variant="body1" align="left" marginTop="12px">
              When a valuable employee leaves, it can cost a company up to <b>150%</b> of their annual salary in lost productivity, recruitment, onboarding, and training. In industries like construction, healthcare, hospitality, professional services, transportation, and sales—where turnover often exceeds <b>40%</b> annually— this creates a massive financial drain.
              <br/>
              Investing just a fraction of those costs into our assessments, can help you identify and retain committed, high-performing employees—reducing turnover and maximizing the value of every hire. Learn more about our methods <a href="/about">here</a>.
              </Typography>
            </Grid>     
            <Grid item xs={12} sm={12} md={12} lg={1}>
              <Typography component="h1" variant="h5" margin="4px" sx={{
    backgroundColor: 'secondary.main',
    borderRadius: '8px', // Adjust this value to change the roundness
    padding: '8px' // Optional: adds breathing room
  }}>
                Hiring Assessment
              </Typography>
              <Box                 sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'center',
                }}>
                <Typography variant="body1" align="left" marginTop="12px">
                  This assessment is for prospective employees and helps establish a candidate's:
                  <List>
                    <ListItem sx={{ display: 'list-item' }}> <CircleIcon fontSize='small' />  Discipline</ListItem>
                    <ListItem sx={{ display: 'list-item' }}><CircleIcon fontSize='small' />  Agreeability</ListItem>
                    <ListItem sx={{ display: 'list-item' }}><CircleIcon fontSize='small' />  Commitment</ListItem>
                    <ListItem sx={{ display: 'list-item' }}><CircleIcon fontSize='small' />  Drive</ListItem>
                    <ListItem sx={{ display: 'list-item' }}><CircleIcon fontSize='small' />  Extraversion</ListItem>
                    <ListItem sx={{ display: 'list-item' }}><CircleIcon fontSize='small' />  Optimism</ListItem>
                    <ListItem sx={{ display: 'list-item' }}><CircleIcon fontSize='small' />  Risk-taking Proclivity</ListItem>
                  </List>
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={1}>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                }}
              >
              <Typography component="h1" variant="h5" margin="4px" sx={{
    backgroundColor: 'secondary.main',
    borderRadius: '8px', // Adjust this value to change the roundness
    padding: '8px' // Optional: adds breathing room
  }}>
              Sample Question
              </Typography>
              <Typography variant="body1" align="center" marginTop="12px">
                <FormControl> 
                <FormLabel align="left" id="radio-group-label" sx={{"&.Mui-focused": { color: "black" } }}><Typography sx={{ color: "black", backgroundColor: 'extra.main'}}>My contributions at work matter.</Typography>
                <br></br>
                <RadioGroup
                  row
                  name="position"
                  defaultValue="Strongly Agree"
                  aria-labelledby="radio-group-label"
                  sx={{
                    display: 'flex',
                    flexWrap: 'wrap',          // allow radios to wrap
                    justifyContent: 'center',  // center them neatly
                    gap: 2,                    // spacing between radios
                    width: '100%',
                    '& .MuiFormControlLabel-root': {
                      flex: '1 1 auto',        // let each radio flex to fit
                      minWidth: { xs: '100%', sm: 'auto' }, 
                      // on mobile: full width (one per line)
                      // on larger screens: auto sizing
                      whiteSpace: 'normal',    // allow text to wrap
                      textAlign: 'center',     // keep labels aligned
                    },
                  }}
                >
                  <FormControlLabel value="Strongly Disagree" control={<Radio />} label="Strongly Disagree" />
                  <FormControlLabel value="Disagree" control={<Radio />} label="Disagree" />
                  <FormControlLabel value="Neutral" control={<Radio />} label="Neutral" />
                  <FormControlLabel value="Agree" control={<Radio />} label="Agree" />
                  <FormControlLabel value="Strongly Agree" control={<Radio />} label="Strongly Agree" />
                </RadioGroup>
                </FormLabel>
              </FormControl>
              </Typography>
              </Box>
            </Grid>   
            <Grid item xs={12} sm={12} md={12} lg={1}>
              <Typography component="h1" variant="h5" margin="4px" sx={{
    backgroundColor: 'secondary.main',
    borderRadius: '8px', // Adjust this value to change the roundness
    padding: '8px' // Optional: adds breathing room
  }}>
              Report Sample
              </Typography>
              <Typography variant="body1" color="text.secondary" align="center" marginTop="12px">
              <img src={samplereport} alt="samplereport" style={{maxWidth: "773px", maxHeight: "1447px", width: "100%", height: "auto"}} />
              </Typography>
            </Grid>   
          {/*
            <Grid item xs={1}>

            <Typography component="h1" variant="h5" margin="4px"  sx={{
    backgroundColor: 'secondary.main',
    borderRadius: '8px', // Adjust this value to change the roundness
    padding: '8px' // Optional: adds breathing room
  }}>
              Founder Survey
            </Typography>
            <Typography variant="body1" color="text.secondary" align="left" marginTop="12px">
              This survey is for founders. Venture capitalists may use this survey to identify ideal founders to invest in. This survey helps establish the candidate's:
            </Typography>
            <List >
                <ListItem sx={{ display: 'list-item' }}><CircleIcon fontSize='small' /> Optimism</ListItem>
                <ListItem sx={{ display: 'list-item' }}><CircleIcon fontSize='small' /> Drive/determination</ListItem>
                <ListItem sx={{ display: 'list-item' }}><CircleIcon fontSize='small' /> Risk tolerance</ListItem>
                <ListItem sx={{ display: 'list-item' }}><CircleIcon fontSize='small' /> Analytical thinking</ListItem>
                <ListItem sx={{ display: 'list-item' }}><CircleIcon fontSize='small' /> Locus of control</ListItem>
              </List>
            </Grid>
        */}
          </Grid>
        </Box>
        <Copyright sx={{ mt: 5 }} />
      </Container>
  </Box>
    </ThemeProvider>
  );
}

export default Home;